import { ActionReducerMapBuilder } from "@reduxjs/toolkit"
import { BikeLabelOrderIndexStepEnum, BikeLabelOrderState } from "../types"
import { getLabelOrderProductThunk, postLabelOrderThunk } from "./bikeLabelOrderThunks"
import { CheckOutStateEnum } from "store/type"

export const handleProductLabelOrderSliceBuilder = (
	builder: ActionReducerMapBuilder<BikeLabelOrderState>
) => {
	builder.addCase(getLabelOrderProductThunk.pending, (state, action) => {
		state.checkOutStateProduct = CheckOutStateEnum.LOADING
		state.finishOrder = false
	})
	builder.addCase(getLabelOrderProductThunk.rejected, (state, action) => {
		state.checkOutStateProduct = CheckOutStateEnum.ERROR
	})
	builder.addCase(getLabelOrderProductThunk.fulfilled, (state, action) => {
		state.finishOrder = false
		state.checkOutStateProduct = CheckOutStateEnum.READY
		state.products = action.payload.map((product) => ({ ...product, quantity: 0 }))
	})
}

export const handlePostOrderSliceBuilder = (
	builder: ActionReducerMapBuilder<BikeLabelOrderState>
) => {
	builder.addCase(postLabelOrderThunk.pending, (state, action) => {
		state.checkOutStateOrderPost = CheckOutStateEnum.LOADING
	})
	builder.addCase(postLabelOrderThunk.rejected, (state, action) => {
		state.checkOutStateOrderPost = CheckOutStateEnum.READY
	})
	builder.addCase(postLabelOrderThunk.fulfilled, (state, action) => {
		state.orderCustomID = action.payload.order_custom_id
		state.products = state.products.map((product) => ({ ...product, quantity: 0 }))
		state.checkOutStateOrderPost = CheckOutStateEnum.READY
		state.validatedLabelOrderStep = BikeLabelOrderIndexStepEnum.SUMMARY_STEP
	})
}
